// extracted by mini-css-extract-plugin
export default {"tileWrapper":"_a68a4224","favoritesWrapper":"_b76aa257","heartIconWrapper":"_4731e11","showLightBox":"_1f174ceb"};